// removed by extract-text-webpack-plugin
module.exports = {"container":"_1_a9RPwM2bfWkJLNTBCvqM"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Course/CourseView.css
// module id = 1185
// module chunks = 0